import React, { useState, useEffect, useRef, createRef } from "react";
import { Col, Row, Tooltip } from "reactstrap";
import { Link } from "react-router-dom";

//API
import tipoRequerimento_api from "../../../../api/tipoRequerimento_api";
import requerimento_api from "../../../../api/requerimento";

//Imagem do Arquivo
import ImgArquivoBlue from "../../../../assets/img/arquivoBlue.png"
import ImgArquivoVermelho from "../../../../assets/img/arquivoVermelho.png"

//Helpers
import { showMessage } from "../../../../helpers/message";
import downloadBase64File from "../../../../helpers/downloadFile";

//Context
import { useAuth } from "../../../../context/auth";

function Documentos({ requerimento, setRequerimento, setDocumento, loadRequerimento, errors, setErrors }) {
  const { setLoading, setShowNavigation } = useAuth();

  //State para pegar os tipos de documentos de acordo com o tipo de requerimento
  const [documentos, setDocumentos] = useState([]);


  useEffect(() => {
    if (requerimento) {
      setLoading(true);
      tipoRequerimento_api
        .getListDocumentos(requerimento.tipoRequerimento_Id, requerimento.id)
        .then((response) => {

          response.data = response.data.map(value => {
            value.ref = createRef(null);
            value.toolTip = false;
            return value;
          })
          const _errors = [...response.data.filter(value => value.obrigatorio && !requerimento.requerimentoDocumentos_Ids.some(arquivoAdicionado => arquivoAdicionado.documento_Id == value.id))];
          setErrors(_errors);
          setDocumentos(response.data);
        })
        .catch(err => showMessage("Error", err.Message, "error", null))
        .finally(f => setLoading(false));
    }

  }, []);

  //Função de onChange do arquivo
  const handleFileChange = (documento, e, value) => {
    const FR = new FileReader();
    const documentoFiltro = requerimento.requerimentoDocumentos_Ids.filter(x => x.documento_Id == documento.id);
    const fileData = documentoFiltro.length > 0
      ? documentoFiltro[0]
      : {
        requerimento_Id: requerimento.id,
        documento_Id: documento.id,
        arquivo: "",
      };

    FR.addEventListener("load", function (evt) {
      fileData.arquivo = evt.target.result;
      delete fileData.base64;
      setLoading(true);
      if (!fileData.id) {
        requerimento_api.postDocumento(fileData).then(response => {
          loadRequerimento();
          const _errors = [
            ...errors.filter(value => value.id != response.data.documento_Id)
          ];
          setErrors(_errors);
        }).catch(ex => showMessage("Aviso", ex.Message, "error", null))
          .finally(f => setLoading(false));
      } else {
        requerimento_api.putDocumento(fileData).then(response => {
          loadRequerimento();
        }).catch(ex => showMessage("Aviso", ex.Message, "error", null))
          .finally(f => setLoading(false));
      }
    });
    if (e.target.files)
      FR.readAsDataURL(e.target.files[0]);
  };


  const handleClickCard = (ref) => {
    ref.current.click();
  };

  const downloadArquivoDocumento = (documento) => {
    if (documento.tipo == "Arquivo")
      downloadBase64File(documento.base64, documento.identificacao.trim() + '.pdf');
    else {
      setShowNavigation(false);
      setDocumento(documento);
    }
  }

  const toggleTooltip = (documento) => {
    setDocumentos(documentos.map(value => {
      if (value.id == documento.id)
        value.toolTip = !value.toolTip;
      else
        value.toolTip = false;
      return value;
    })
    )
  }


  return (
    <>
      <Row className="mx-4">
        <Col md="12" lg="12">
          <h6 style={{ color: "#666" }}>Clique no icone para anexar um documento</h6>
        </Col>
      </Row>
      <Row className="mx-4 mb-4 h-100">
        {!!documentos && requerimento &&
          documentos.map((value, index) => (
            <Col md="12" lg="4" className="h-100 mb-4" key={index}>
              <div
                className={`bg-white py-3  rounded shadow h-100`}
                style={{
                  border: requerimento.requerimentoDocumentos_Ids && requerimento.requerimentoDocumentos_Ids.some(arquivoAdicionado => arquivoAdicionado.documento_Id == value.id) ? "2px solid blue" : "2px solid red",
                  cursor: "pointer",
                  position: "relative"
                }}
              >
                {value.orientacoes != "" &&
                  <>
                    <Tooltip placement="top" isOpen={value.toolTip} target="Tooltip" toggle={() => toggleTooltip(value)}>
                      {value.orientacoes}
                    </Tooltip>
                    <span id="Tooltip" className="tooltipDocumento">?</span>
                  </>
                }
                <div className="d-flex justify-content-center align-items-center gap-3 h-100">
                  <div onClick={() => handleClickCard(value.ref)}>
                    {requerimento.requerimentoDocumentos_Ids && requerimento.requerimentoDocumentos_Ids.some(arquivoAdicionado => arquivoAdicionado.documento_Id == value.id) ? <img src={ImgArquivoBlue} alt="Imagem do arquivo" /> : <img src={ImgArquivoVermelho} alt="Imagem do arquivo" />}
                  </div>
                  <div>
                    <h6 className="fw-bold" style={{ color: "#666", fontSize: "11pt" }}>{(value.obrigatorio ? "*" : "") + value.identificacao}</h6>
                    <Link
                      role="button"
                      className="text-primary"
                      onClick={() => handleClickCard(value.ref)}
                    >Anexar documento</Link>
                  </div>
                </div>
              </div>
              {value.base64 &&
                <div className="mt-2">
                  <Link
                    role="button"
                    className="text-primary"
                    style={{ fontSize: "9pt" }}
                    onClick={() => downloadArquivoDocumento(value)}
                  >Baixar Modelo</Link>
                </div>
              }
              {value.conteudo &&
                <div className="mt-2">
                  <Link
                    role="button"
                    className="text-primary"
                    style={{ fontSize: "9pt" }}
                    onClick={() => setDocumento(value)}
                  >Baixar Modelo</Link>
                </div>
              }
              <input
                type="file"
                ref={value.ref}
                onChange={(e) => handleFileChange(value, e, value)}
                style={{ display: "none" }}
              />
            </Col>
          ))}
      </Row>
    </>
  );
}

export default Documentos;
